import { useQuery } from 'react-query'

import request from '../config/axios'

interface ConsentStatus {
  consented: boolean
}

interface UseConsentPollingOptions {
  enabled: boolean
  patientId: string
  onSuccess?: (data: ConsentStatus) => void
}

const useConsentPolling = ({
  enabled,
  patientId,
  onSuccess,
}: UseConsentPollingOptions) => {
  return useQuery(
    ['consent-status', patientId],
    async (): Promise<ConsentStatus> => {
      const response = await request.get<ConsentStatus>(
        `/patients/open/consents/status`,
        {
          params: { patient_id: patientId },
        },
      )
      return response.data
    },
    {
      enabled: enabled && !!patientId,
      refetchInterval: enabled ? 2000 : false,
      refetchIntervalInBackground: false,
      onSuccess: (data) => {
        if (data.consented && onSuccess) {
          onSuccess(data)
        }
      },
    },
  )
}

export default useConsentPolling
